/**
 * Opciones del selector de «registros por página», compartidas por TODOS los listados.
 *
 * <p>Antes cada componente llevaba su propia copia del array — treinta copias que ya habían
 * divergido: la mayoría ofrecía hasta 50 y Tareas hasta 100. El resultado era que el mismo
 * control daba opciones distintas según la pantalla, lo que se lee como un fallo y no como
 * una decisión. Con la lista aquí, subir el tope vuelve a ser una línea y no treinta.</p>
 *
 * <p>Se conservan los valores pequeños (5, 10, 20, 50) a propósito: si se retirara alguno,
 * quien lo tuviera seleccionado se quedaría con el desplegable sin coincidencia y saltando
 * a otro valor sin avisar. Añadir no rompe a nadie; quitar sí.</p>
 *
 * <p>El salto entre opciones se mantiene en torno a ×2–×2,5. Un salto directo de 100 a 500
 * dejaría sin respuesta el caso que motivó la ampliación —ver un par de cientos de golpe— y
 * empujaría a pedir el máximo por no haber nada intermedio.</p>
 */
/*
 * El tipo es `number[]` y no `readonly number[]` a propósito: algunos listados pasan esta
 * lista como @Input a un paginador hijo cuya entrada está tipada `number[]`, y TypeScript
 * no acepta ahí un array de solo lectura. Marcarla readonly rompía el build de
 * FormsListComponent.
 */
export const PAGE_SIZE_OPTIONS_DEFAULT: number[] = [5, 10, 20, 50, 100, 200, 500];
